import React, { useCallback, useMemo, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { Drawers, RecruiterLayout } from 'features/command-center';
import { DrawerManagerProvider, RecruiterInfoProvider } from 'features/command-center/contexts';
import { useRefreshStats } from 'features/command-center/hooks';
import strings from 'strings';
import TabsView from 'UI/components/templates/TabsView';

import { Activity } from './Activity';
import { PilGrowth } from './PilGrowth';
import { useStyles } from './Recruiter.styles';
import { RecruiterOverview } from './RecruiterOverview';

const STRINGS = strings.commandCenter.activity.recruiter;

export const Recruiter = ({ id, match }) => {
  const classes = useStyles();
  const [recruiterName, setRecruiterName] = useState('');
  const [teamId, setTeamId] = useState('');
  const { refreshData, refreshKey } = useRefreshStats();

  const recruiterId = id ?? match?.params?.id;

  const handleRecruiterLoaded = useCallback(recruiterData => {
    setRecruiterName(recruiterData?.recruiterName ?? '');
    setTeamId(recruiterData?.managerEmpNo);
  }, []);

  const TABS = useMemo(
    () => [
      {
        id: 'recruiterOverview',
        label: STRINGS.tabs.overview,
        view: <RecruiterOverview recruiterId={recruiterId} key={refreshKey} />
      },
      {
        id: 'pilGrowth',
        label: STRINGS.tabs.pilGrowth,
        view: <PilGrowth recruiterId={recruiterId} teamId={teamId} key={refreshKey} />
      },
      {
        id: 'activity',
        label: STRINGS.tabs.activity,
        view: <Activity recruiterId={recruiterId} teamId={teamId} key={refreshKey} />
      }
    ],
    [recruiterId, refreshKey, teamId]
  );

  return (
    <DrawerManagerProvider>
      <RecruiterInfoProvider recruiterId={recruiterId} onRecruiterLoaded={handleRecruiterLoaded}>
        <RecruiterLayout onRefresh={refreshData}>
          <Grid item xs={12}>
            <TabsView
              enableUrlNavigation
              initialTab="recruiterOverview"
              panelHeight="unset"
              tabs={TABS}
              tabPanelProps={{
                className: classes.tab
              }}
              useIndexes={false}
            />
          </Grid>
        </RecruiterLayout>
        <Drawers prefixTitle={recruiterName ?? ''} />
      </RecruiterInfoProvider>
    </DrawerManagerProvider>
  );
};
